
import Privacy from "./privacidad"

import './style.css'

import { BrowserRouter as Router, Route } from "react-router-dom";

function App() {
  return (
    <Router>
        <div className={"site-content"}>
        <Route path="/" exact component={welcome} />
        <Route path="/fireqr/privacidad/" component={Privacy} />
      </div>
    </Router>
  );
}

function welcome() {
  return (
    <p>Welcome</p>
  );
}

export default App;
